import { Box, styled, TextField } from '@mui/material';
import {
  Controller,
  Control,
  FieldValues,
  DeepMap,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';
import { getFormFieldError } from '../../helpers';

interface CompoundInputProps {
  placeholder?: string;
  name: string;
  control: Control<any>;
  required?: boolean;
  errors?: DeepMap<FieldValues, FieldError>;
  rules?: RegisterOptions;
  children?: React.ReactNode;
  onSubmit?: () => void;
}

const PREFIX = 'CompoundInput';

const componentClasses = {
  wrapper: `${PREFIX}-wrapper`,
  input: `${PREFIX}-input`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${componentClasses.wrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  [`&.${componentClasses.input}`]: {
    border: '1px dotted black',
    [`&.MuiOutlinedInput-root`]: {
      border: 'none',
      boxShadow: 'none',
    },
  },
}));

const CompoundInput = ({
  name,
  control,
  placeholder,
  required = false,
  errors,
  rules,
  children,
  onSubmit,
}: CompoundInputProps) => {
  const error = errors ? getFormFieldError(name, errors) : null;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <StyledBox className={componentClasses.wrapper}>
          <TextField
            className={componentClasses.input}
            placeholder={placeholder}
            variant="outlined"
            fullWidth
            multiline
            maxRows={8}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                onSubmit?.();
              }
            }}
            {...field}
          />
          <Box className={componentClasses.input}>{children}</Box>
        </StyledBox>
      )}
    />
  );
};

export { CompoundInput };
